import RequiredValidator from "@/validators/RequiredValidator";

export default class PaymentTypeRules {

	public static readonly codeRules = [
		(new RequiredValidator('paymentType.code')).validationRule(),
	];

}
